import EditTask from '../components/Home/EditTask/EditTask';

const EditTaskPage = () => {
  return <EditTask />;
};

export default EditTaskPage;
